import type { ComponentPropsWithoutRef } from "react";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import "./ProductQuantityError.scss";

type ProductQuantityErrorType = {
  isVisible?: boolean;
  quantityLimit?: string | number;
  className?: string;
} & ComponentPropsWithoutRef<"div">;

export const ProductQuantityError = ({
  isVisible = true,
  quantityLimit = "-",
  className,
  ...restProps
}: ProductQuantityErrorType) => {
  const { __ } = useTranslations();
  return (
    <div className={`product-quantity-error ${className ?? ""}`} {...restProps}>
      {isVisible && (
        <AlertBanner tone="warning" description={`${__("libs.ui.notification.limit.sku")} (${quantityLimit})`} />
      )}
    </div>
  );
};
